import * as R from 'ramda';


/**
 * filterAttachments :: ID -> Object -> [Attachment]
 */
export const filterAttachments = requestId => R.compose(
  R.filter(R.propEq('requestId', requestId)),
  R.values,
  R.pathOr({}, ['attachments', 'items']),
);



// WEBPACK FOOTER //
// ./src/containers/request-attachments/utils.js